import { Alert } from "react-bootstrap";

export default function ErrorPage() {
  return (
    <Alert variant="danger" className="mt-4" role="alert">
      The approved activities list is unavailable.
    </Alert>
  );
}
